/* Entry point: mounts <App /> into #root.
 *
 * Stylesheets are imported as ES modules so Vite resolves them through the
 * normal dependency graph — this includes design-system/tokens.css which
 * lives outside frontend/ and otherwise wouldn't be reachable via a <link>
 * with a relative URL. */

import '../../design-system/tokens.css';
import '../styles.css';
import '../styles-mark.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.jsx';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
